import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AdvisorListComponent } from './advisor-list.component';
import { Partner } from './advisor.model';

@Component({
    selector: 'app-advisor-dialog-info',
    templateUrl: './advisor-dialog-info.component.html',
    styleUrls: ['./advisor-list.component.css'],
    standalone: false
})
export class AdvisorDialogInfoDialog implements OnInit {
  dataSource:Partner = this.data.Partner;
  displayedColumns: string[] = [
    'Usuario',
    'Activado',
    'Suscrito',
    'Fecha Creación',
    'Fecha Fin Subscripción',
    'Subscripción',
    'Precio'
  ];
  //dataSource = new MatTableDataSource<Partner>([this.Partner]);
  constructor(
    public dialogRef: MatDialogRef<AdvisorListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any

  )  {}


  ngOnInit() {
    //console.log(this.Partner);
  }

}



